import { BEOMStore } from "./dataStore";
import { spreadsheetGenreMixesLookup } from "./spreadsheetData";

export class TheBrain {

    constructor(public data: BEOMStore) {

    }




    // getStreamingMix = () => {
    //     const genre = this.getGenreMix();
    //     if (!genre) return 0;
    //     return genre.streaming;
    // }

    // getTrackVsAlbumMix = () => {
    //     const genre = this.getGenreMix();
    //     if (!genre) return 0;
    //     return genre.trackVsAlbum;
    // }

    // getDigitalVsPhysicalMix = () => {
    //     const genre = this.getGenreMix();
    //     if (!genre) return 0;
    //     return genre.digitalVsPhysical;
    // }

    getTotalSpend = () => {
        const d = this.data.spend;
        return d.admin + d.manufacturing + d.marketing + d.other + d.recording;
    }


    E7 = () => this.data.info.format;
    E8 = () => this.data.info.doingPhysical;
    E20 = () => this.getTotalSpend();
    E25 = () => this.I25() == 0 ? 0 : this.K25() / this.J25();
    E32 = () => this.I32() == 0 ? 0 : this.K32() / this.J32();
    E35 = () => this.I35() == 0 ? 0 : Math.round(this.K35() / this.J35());
    E38 = () => this.I38() == 0 ? 0 : Math.round(this.K38() / this.J38());
    I6 = () => this.data.breakEven.streamingRatio * 100;
    I25 = () => this.I6();
    I32 = () => this.E7() == "Album" ? (100 - this.I25()) * this.L32() / 100 : (100 - this.I25()); // =IF(E7="Album",(100-I25)*L32/100,(100-I25))
    I35 = () => (this.I25() + this.I32() == 100)
        ? 0
        : (this.E7() == "Album" && this.E8() == "Nah")
            ? (100 - this.I25()) * this.L35() / 100
            : (100 - this.I25()) * this.L35() / 100 * this.M35() / 100
        ;
    I38 = () => this.E8() == "Nah"
        ? 0
        : this.E7() == "Album"
            ? (100 - this.I25()) * this.L35() / 100 * this.M38() / 100
            : 0;
    J25 = () => this.data.rates.perStreamRate;
    J38 = () => this.E8() == "Yep, vinyl"
        ? this.data.rates.vinylAlbumPrice
        : this.E8() == "Yep, CDs"
            ? this.data.rates.cdAlbumPrice
            : this.E8() == "A bit of both"
                ? (this.data.rates.vinylAlbumPrice + this.data.rates.cdAlbumPrice) * 0.5
                : 0
    J32 = () => this.data.rates.digitalTrackPrice;
    J35 = () => this.data.rates.digitalAlbumPrice;
    K25 = () => (this.E20() * this.I25()) / 100;
    K32 = () => this.E20() * this.I32() / 100; //$E$20*I32/100;
    K35 = () => this.E20() * this.I35() / 100;
    K38 = () => this.E20() * this.I38() / 100
    L32 = () => {
        return this.data.breakEven.trackVsAlbumsRatio * 100;
    }
    L35 = () => 100 - this.L32();
    M6 = () => this.data.breakEven.digitalVsPhysicalRatio * 100;
    M35 = () => this.M6()
    M38 = () => 100 - this.M35();


    getStreamingUnits = () => {
        // debugger;
        return Math.round(this.E25());
    }
    getStreamingIncome = () => this.K25();

    getTrackDownloadUnits = () => Math.round(this.E32());
    getTrackDownloadIncome = () => this.K32();

    getAlbumDownloadUnits = () => Math.round(this.E35());
    getAlbumDownloadIncome = () => this.K35();

    // =IF(I38<>0,ROUND(K38/J38,0),0)
    getPhysicalAlbumUnits = () => Math.round(this.E38());
    getPhysicalAlbumIncome = () => this.K38();

    getGenreMix = () => spreadsheetGenreMixesLookup.get(this.data.info.genre);

    //     target = {
    //         streams
    // trackDownloads
    // albumDownloads
    // physicalAlbums
    // total
    //     }


}